export const formatCurrency = (value) => {
    if (value == null || isNaN(value)) return "0.00";

    const number = Number(value);
    return number.toLocaleString("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

export function formatNumber(value, decimalPlaces = 2) {
    if (isNaN(value)) return '';

    const [integerPart, decimalPart] = Number(value)
        .toFixed(decimalPlaces)
        .split('.');

    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
}

export const ThousandSeparator = (amount) => {
    var returnValue = amount
    if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
        var numberParts = amount.split('.')
        var partBeforeDecimalPlace = numberParts[0]
        var partAfterDecimalPlace = '00'

        if (numberParts.length > 1) {
            partAfterDecimalPlace = numberParts[1]
        }

        returnValue = partBeforeDecimalPlace.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        returnValue += '.' + partAfterDecimalPlace
    }
    return returnValue
}

export const RoundToTwoDecimalPlaces = (value) => {
    return Number((+(Math.round(value + 'e+2') + 'e-2')).toFixed(2))
}

export const RoundToTwoDecimalPlacesAsString = (value) => {
    return (+(Math.round(value + 'e+2') + 'e-2')).toFixed(2)
}

export const RoundToFourDecimalPlacesAsString = (value) => {
    return (+(Math.round(value + 'e+4') + 'e-4')).toFixed(4)
}

export const RoundToTwoDecimalPlacesWithThousandSeparatorsAsString = (value) => {
    return ThousandSeparator(RoundToTwoDecimalPlacesAsString(value))
}

export const RoundToFourDecimalPlaces = (value) => {
    return Number((+(Math.round(value + 'e+4') + 'e-4')).toFixed(4))
}